var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgChevronWithCircle = function SvgChevronWithCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.416,
    cy: 98.814,
    r: 21.613,
    fill: "#F1F1F1",
    transform: "rotate(-90 95.416 98.814)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.331,
    cy: 41.835,
    r: 21.613,
    fill: "#F1F1F1",
    transform: "rotate(-90 44.331 41.835)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M104.258 48.202 106 33.648l14.554 1.744-1.743 14.554zM19.444 107.877l3.21-14.302 14.303 3.21-3.21 14.303z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B69D1",
    d: "M71.164 37.578c-18.949 0-34.364 15.13-34.364 33.729s15.415 33.729 34.364 33.729c18.95 0 34.365-15.13 34.365-33.73 0-18.598-15.415-33.728-34.365-33.728"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.76 82.45q-.75.3-1.426-.132-.676-.43-.676-1.256v-5.59q0-.525.3-.939.3-.412.826-.525l10.881-2.701-10.881-2.702a1.33 1.33 0 0 1-.826-.525q-.3-.413-.3-.938V61.55q0-.825.676-1.258.675-.43 1.425-.13l23.114 9.755q.938.413.938 1.388 0 .976-.938 1.389z"
  })));
};
export default SvgChevronWithCircle;